import styled from 'styled-components';

const PressCellLink = styled.a`
  font-family: "Avenir", "Arial", sans-serif;
  font-weight: 900;
  ${({ isDesktop }) => (isDesktop ? 'font-size: 30px' : 'font-size: 15px')};
  letter-spacing: 1px;
  ${({ isDesktop }) => (isDesktop ? 'line-height: 41px' : 'line-height: 20px')};
`;

export default PressCellLink;
